import { updateValueService } from "../shared/updateValueService";
import {
    PRODUCT_FORM_GRAIN,
} from "../constant";
import defaultI18n from "../i18nService";
import { PHRASE_URL_PART, PREFERENCE_URL, PROPERTIES_URL, deleteFetchRequest, getFetchRequest, postFetchRequest, putFetchRequest } from "../store/requests";
import { productsStorage } from "./productsStorage";
import { propertiesService } from "./propertiesService";
import { propertiesStorage } from "./propertiesStorage";
import {errorCallback, makeUrl, successCallbackEmpty} from "../util";
import {productsService} from "./productsService";
import {Group, Phrase, Preference, PreferenceFrequency, PreferenceItemCode, PreferenceType, KashaConsistencyPreferenceItem} from "./preferenceTypes";
import {lastUpdateTimeService} from "./lastUpdateTimeService";
import {RecipeCharacteristicCategory, RecipeType} from "./recipeTypes";
import {Locale} from "./commonTypes";
import {ProductCategory} from "../productTypes";
import { checkItemLocaleCode } from "../components/helper";

const DEFAULT_PREFERENCE: Preference = {groups: [], combinedPreferences: [], preferenceItemCodes: []};

const createPhraseRequest = (preferenceId: string, phraseContent, callback: Function, i18n = defaultI18n) => {
    const preparedPhrase = {
        locale: i18n.resolvedLanguage,
        content: phraseContent.content,
    };
    putFetchRequest(makeUrl([PREFERENCE_URL, preferenceId, PHRASE_URL_PART]), preparedPhrase, callback, errorCallback);
};

const convertToPhraseUpdateBody = (phraseData) => {
    console.log(phraseData.content);
    return {
        locale: phraseData.locale,
        content: phraseData.content,
    };
};

const transformGroupsList = (groupsList) => {
    return groupsList.map(it => {
        return { groupId: it.id };
    });
};

const isGrain = (product) => product.productForms.findIndex(it => it.formGroup === PRODUCT_FORM_GRAIN) > -1;

const getFromPossibleItemCodeValues = (preferenceType: PreferenceType, itemCode: string, i18n = defaultI18n) => {
    if (!itemCode) {
        return "";
    }
    if(preferenceType === PreferenceType.PRODUCT ) {
        return productsService.getLocalization(i18n.resolvedLanguage, itemCode, true);
    } else if (preferenceType === PreferenceType.PRODUCT_CATEGORY_PER_MEAL || preferenceType === PreferenceType.PRODUCT_CATEGORY_PER_DAY) {
        return i18n.t(`product.scheme.formGroup.${itemCode.toLowerCase()}`);
    } else if (preferenceType === PreferenceType.CEREAL_MIX) {
        return productsService.getLocalization(i18n.resolvedLanguage, itemCode, true);
    } else if (preferenceType === PreferenceType.RECIPE) {
        return i18n.t(`recipe.item.type.${itemCode.toLowerCase()}`);
    } else if (preferenceType === PreferenceType.RECIPE_CHARACTERISTIC) {
        return i18n.t(`app.page.recipe.recipeCharacteristic.${itemCode.toLowerCase()}`);
    } else if (preferenceType === PreferenceType.KASHA_CONSISTENCY) {
        return i18n.t(`preference.scheme.preferenceItem.${itemCode}`);
    } else if(preferenceType === PreferenceType.PROPERTY || preferenceType === PreferenceType.MACRONUTRIENT_PER_DAY || preferenceType === PreferenceType.MACRONUTRIENT_PER_MEAL) {
        return propertiesService.getLocalization(i18n.resolvedLanguage, itemCode, true);
    }
    return "";
};

export const createPossibleItemCodeValues = (preferenceType: PreferenceType, i18n = defaultI18n) => {
    if(preferenceType === PreferenceType.PRODUCT ) {
        return productsStorage.getItems(true).map(it => {
            return {
                id: it.productCode,
                name: productsService.getLocalization(i18n.resolvedLanguage, it.productCode, true),
            };
        });
    } else if (preferenceType === PreferenceType.PRODUCT_CATEGORY_PER_MEAL || preferenceType === PreferenceType.PRODUCT_CATEGORY_PER_DAY) {
        return Object.values(ProductCategory).map(it => {
            return {
                id: it,
                name: i18n.t(`product.scheme.formGroup.${it.toLowerCase()}`),
            };
        });
    } else if (preferenceType === PreferenceType.CEREAL_MIX) {
        return productsStorage.getItems(true)
            .filter(it => isGrain(it))
            .map(it => {
                return {
                    id: it.productCode,
                    name: productsService.getLocalization(i18n.resolvedLanguage, it.productCode, true),
                };
            });
    } else if (preferenceType === PreferenceType.RECIPE) {
        return Object.values(RecipeType).map(it => {
            return {
                id: it,
                name: i18n.t(`recipe.item.type.${it.toLowerCase()}`),
            };
        });
    } else if (preferenceType === PreferenceType.RECIPE_CHARACTERISTIC) {
        return Object.values(RecipeCharacteristicCategory).map(it => {
            return {
                id: it,
                name: i18n.t(`app.page.recipe.recipeCharacteristic.${it.toLowerCase()}`),
            }
        });
    } else if (preferenceType === PreferenceType.KASHA_CONSISTENCY) {
        return Object.values(KashaConsistencyPreferenceItem).map(it => {
            return {
                id: it,
                name: i18n.t(`preference.scheme.preferenceItem.${it}`),
            };
        });
    } else if(preferenceType === PreferenceType.PROPERTY || preferenceType === PreferenceType.MACRONUTRIENT_PER_DAY || preferenceType === PreferenceType.MACRONUTRIENT_PER_MEAL) {
        return propertiesStorage.getItems(true)
            .filter(it => {
                if (preferenceType === PreferenceType.MACRONUTRIENT_PER_DAY || preferenceType === PreferenceType.MACRONUTRIENT_PER_MEAL) {
                    return it.categoryName === "macronutrient";
                }
                return true;
            })
            .map(it => {
                return {
                    id: it.propertyName,
                    name: propertiesService.getLocalization(i18n.resolvedLanguage, it.propertyName, false),
                };
        });
    } else {
        return [];
    }
};

class PreferenceSaveService {
    currentPreference: Preference = {...DEFAULT_PREFERENCE};
    preferenceUpdateObservers: Set<Function> = new Set();
    lastPreferenceUpdateTime: number = null;
    preferenceId: string = '';
    phrasesList: Phrase[] = [];

    loadPreference() {
        try {
            if(this.preferenceId) {
                getFetchRequest(makeUrl([PREFERENCE_URL, this.preferenceId, '/']), (response) => {
                    this.currentPreference = {...response, groups: response.groups ? response.groups : [], isChild: false};
                    this.notifyPreferenceUpdateObservers();
                }, errorCallback);
            }
        } catch(err) {
            console.log(err);
        }
    }

    getPreference(): Preference {
        return this.currentPreference;
    }

    getPreferenceItem(): PreferenceItemCode {
        if (this.currentPreference.preferenceItemCodes && this.currentPreference.preferenceItemCodes.length > 0) {
            return this.currentPreference.preferenceItemCodes[0];
        }
        return {itemCode: ""};
    }

    getCombinedPreferenceItem(index: number): PreferenceItemCode {
        if (index !== null &&
            this.currentPreference.combinedPreferences[index].preferenceItemCodes &&
            this.currentPreference.combinedPreferences[index].preferenceItemCodes.length > 0) {
            return this.currentPreference.combinedPreferences[index].preferenceItemCodes[0];
        }
        return {itemCode: ""};
    }

    fillCombinedPreferenceField(index, propertyKey: string, value) {
        if (index === undefined) {
            this.currentPreference.combinedPreferences.push({isChild: true});
            this.currentPreference.combinedPreferences[this.currentPreference.combinedPreferences.length - 1][propertyKey] = value;
            if(propertyKey === 'preferenceType') {
                this.currentPreference.combinedPreferences[this.currentPreference.combinedPreferences.length - 1].preferenceItemCodes = [];
            }
        } else {
            if (propertyKey === 'itemCode') {
                if(this.currentPreference.combinedPreferences[index].preferenceItemCodes.length === 0) {
                    this.currentPreference.combinedPreferences[index].preferenceItemCodes.push({itemCode: value});
                    return;
                }
                this.currentPreference.combinedPreferences[index].preferenceItemCodes[0].itemCode = value;
                return;
            }
            this.currentPreference.combinedPreferences[index][propertyKey] = value;
            if (propertyKey === 'preferenceType') {
                this.currentPreference.combinedPreferences[index].preferenceItemCodes = [];
            }
        }
    }

    updateCombinedPreferenceItem(index: number, itemFieldKey: string, value, i18n = defaultI18n) {
        try {
            if(this.currentPreference.combinedPreferences[index].preferenceItemCodes.length === 0) {
                this.currentPreference.combinedPreferences[index].preferenceItemCodes.push({itemCode: ""});
            }
            this.currentPreference.combinedPreferences[index].preferenceItemCodes[0][itemFieldKey] = value;
            this.lastPreferenceUpdateTime = Date.now();
            if(this.preferenceId) {
                this.savePreference(i18n);
            }
        } catch(err) {
            console.log(err);
        }
    }

    updateCombinedPreference(index: number, propertyKey: string, value, i18n = defaultI18n) {
        try {
            this.fillCombinedPreferenceField(index, propertyKey, value);
            this.lastPreferenceUpdateTime = Date.now();
            if(this.preferenceId) {
                this.savePreference(i18n);
            }
            this.notifyPreferenceUpdateObservers();
        } catch(err) {
            console.log(err);
        }
    }

    updatePreferenceItem(itemFieldKey: string, value, i18n = defaultI18n) {
        try {
            if(this.currentPreference.preferenceItemCodes.length === 0) {
                this.currentPreference.preferenceItemCodes.push({itemCode: ""});
            }
            this.currentPreference.preferenceItemCodes[0][itemFieldKey] = value;
            this.lastPreferenceUpdateTime = Date.now();
            if(this.preferenceId) {
                this.savePreference(i18n);
            }
        } catch(err) {
            console.log(err);
        }
    }

    updatePreferenceProperty(propertyKey: string, value, i18n = defaultI18n) {
        try {
            if(propertyKey === 'preferenceType' && value !== this.currentPreference.preferenceType) {
                this.currentPreference.preferenceType = value;
                this.currentPreference.preferenceItemCodes = [];
                this.currentPreference.combinedPreferences = [];
            }
            if(propertyKey !== 'preferenceType') {
                this.currentPreference[propertyKey] = value;
            }
            if(this.preferenceId) {
                this.savePreference(i18n);
            }
            this.lastPreferenceUpdateTime = Date.now();
            this.notifyPreferenceUpdateObservers();
        } catch(err) {
            console.log(err);
        }
    }

    savePreference(callback: Function = null, i18n = defaultI18n) {
        try {
            const preparedBody = {
                ...this.currentPreference,
                frequencyPeriod: this.currentPreference.frequencyPeriod ? this.currentPreference.frequencyPeriod : '0',
                combinedPreferences: this.currentPreference.combinedPreferences ? this.currentPreference.combinedPreferences.map(it => {
                    return {
                        isChild: true,
                        preferenceType: it.preferenceType,
                        preferenceItemCodes: it.preferenceItemCodes ? it.preferenceItemCodes : [],
                    };
                }) : [],
                groups: Array.isArray(this.currentPreference.groups) ? this.currentPreference.groups : [this.currentPreference.groups],
            };
            if(this.preferenceId) {
                postFetchRequest(makeUrl([PREFERENCE_URL, this.preferenceId, '/']), preparedBody, successCallbackEmpty, errorCallback, true);
            } else {
                postFetchRequest(makeUrl([PREFERENCE_URL]), preparedBody, (response) => {
                    this.savePhrases(i18n);
                    postFetchRequest(makeUrl([PREFERENCE_URL, response.id, '/group/']), transformGroupsList(preparedBody.groups), () => {
                        this.lastPreferenceUpdateTime = Date.now();
                        this.cleanService();
                        callback && callback();
                    }, errorCallback, true);
                }, errorCallback);
            }
        } catch(err) {
            console.log(err);
        }
    }

    regeneratePhrases() {
        if(this.preferenceId) {
            postFetchRequest(makeUrl([PREFERENCE_URL, this.preferenceId, '/phrase/']), {}, successCallbackEmpty, errorCallback, true);
        }
    }

    updateHowOften(frequencyType: PreferenceFrequency, frequencyPeriod: number, i18n = defaultI18n) {
        this.currentPreference.preferenceFrequency = frequencyType;
        this.currentPreference.frequencyPeriod = frequencyPeriod;
        if(this.preferenceId) {
            this.savePreference(i18n);
        }
        this.lastPreferenceUpdateTime = Date.now();
        this.notifyPreferenceUpdateObservers();
    }

    updatePreferencePropertyGroup(group: Group) {
        const index = this.currentPreference.groups.findIndex(it => it.id === group.id);
        if(index >= 0) {
            this.currentPreference.groups = this.currentPreference.groups.filter(it => it.id !== group.id);
            if(this.preferenceId) {
                deleteFetchRequest(makeUrl([PREFERENCE_URL, this.preferenceId, '/group/']), () => {
                    this.lastPreferenceUpdateTime = Date.now();
                    this.notifyPreferenceUpdateObservers();
                }, errorCallback, [{groupId: group.id}]);
            }
        } else {
            this.currentPreference.groups.push(group);
            if(this.preferenceId) {
                postFetchRequest(makeUrl([PREFERENCE_URL, this.preferenceId, '/group/']), [{groupId: group.id}], () => {
                    this.lastPreferenceUpdateTime = Date.now();
                    this.notifyPreferenceUpdateObservers();
                }, errorCallback, true);
            }
        }
    }

    loadPhrases(callback: Function) {
        if (this.preferenceId) {
            getFetchRequest(makeUrl([PREFERENCE_URL, this.preferenceId, PHRASE_URL_PART, '?onlyGenerated=false']), (response) => {
                if(response.length) {
                    this.phrasesList = [...response];
                }
                callback();
            }, errorCallback);
        }
    }

    getPhrases(): Phrase[] {
        return this.phrasesList;
    }

    updatePreferencePhrases(value: string, phraseId: string, isNew: boolean = false, i18n = defaultI18n) {
        this.phrasesList.forEach(it => {
            if (it.id === phraseId) {
                it.content = value;
            }
        });
        if (this.phrasesList.filter(it => it.id === phraseId).length === 0 && isNew) {
            this.phrasesList.push({id: phraseId, content: value, locale: i18n.resolvedLanguage, isNew: true});
        } else {
            this.phrasesList.forEach(it => {
                if (it.id === phraseId) {
                    it.content = value;
                }
            })
        }
        this.savePhrases(i18n);
    }

    savePhrase(phraseId: string, phraseData = {}, callback: Function = () => {}, i18n = defaultI18n) {
        if(this.preferenceId) {
            updateValueService.updateItemValue(() => {
                if (!phraseId) {
                    createPhraseRequest(this.preferenceId, phraseData, (response) => {
                        this.phrasesList.push(response);
                        this.lastPreferenceUpdateTime = Date.now();
                        lastUpdateTimeService.notifyUpdateEvent();
                        if (callback) {
                            callback(response.id);
                        }
                    }, i18n);
                } else {
                    this.phrasesList.filter(it => it.id === phraseId).forEach(it => {
                        postFetchRequest(makeUrl([PREFERENCE_URL, this.preferenceId, PHRASE_URL_PART, it.id, '/']),
                            convertToPhraseUpdateBody(it), () => {
                                this.lastPreferenceUpdateTime = Date.now();
                                lastUpdateTimeService.notifyUpdateEvent();
                            }, errorCallback, true);
                    });
                }
            });
        }
    }

    savePhrases(i18n) {
        if(this.preferenceId) {
            updateValueService.updateItemValue(() => {
                this.phrasesList.forEach(it => {
                    if (it.isNew) {
                        createPhraseRequest(this.preferenceId, it, (response) => {
                            it.isNew = false;
                            it.id = response.id;
                            this.lastPreferenceUpdateTime = Date.now();
                            lastUpdateTimeService.notifyUpdateEvent();
                        }, i18n);
                    } else {
                        postFetchRequest(makeUrl([PREFERENCE_URL, this.preferenceId, PHRASE_URL_PART, it.id, '/']),
                            convertToPhraseUpdateBody(it), () => {
                                this.lastPreferenceUpdateTime = Date.now();
                                lastUpdateTimeService.notifyUpdateEvent();
                            }, errorCallback, true);
                    }
                });
            });
        }
    }

    deletePhrase(phraseId: string) {
        const phrase = this.phrasesList.filter(it => it.id === phraseId);
        if(this.preferenceId && phrase && phrase.length) {
            deleteFetchRequest(makeUrl([PREFERENCE_URL, this.preferenceId, PHRASE_URL_PART, phraseId, '/']), () => {
                this.lastPreferenceUpdateTime = Date.now();
                lastUpdateTimeService.notifyUpdateEvent();
            }, errorCallback);
            this.phrasesList = this.phrasesList.filter(it => it.id !== phraseId);
        }
    }

    registerItemUpdateObserver(observer) {
        this.preferenceUpdateObservers.add(observer);
    }

    unRegisterItemUpdateObserver(observer) {
        this.preferenceUpdateObservers.delete(observer);
    }

    notifyPreferenceUpdateObservers() {
        this.preferenceUpdateObservers.forEach((preferenceUpdateObserver: Function) => preferenceUpdateObserver());
    }

    getDateLastUpdate(): number {
        return this.lastPreferenceUpdateTime;
    }

    cleanService() {
        this.currentPreference = {...DEFAULT_PREFERENCE};
        this.preferenceUpdateObservers = new Set();
        this.lastPreferenceUpdateTime = null;
        this.preferenceId = '';
        this.phrasesList = [];
    }

    getSelectedCodeValue(parentMode: boolean = true, index: number = undefined, itemCode: string = '', i18n = defaultI18n) {
        if(parentMode) {
            return getFromPossibleItemCodeValues(this.currentPreference.preferenceType, itemCode, i18n);
        } else {
            if(index === undefined) {
                return [];
            } else {
                return getFromPossibleItemCodeValues(this.currentPreference.combinedPreferences[index].preferenceType, itemCode, i18n);
            }
        }
    }

    getPossibleCodeValues(parentMode: boolean = true, index: number = undefined, i18n = defaultI18n) {
        if(parentMode) {
            return createPossibleItemCodeValues(this.currentPreference.preferenceType, i18n);
        } else {
            if(index === undefined) {
                return [];
            } else {
                return createPossibleItemCodeValues(this.currentPreference.combinedPreferences[index].preferenceType, i18n);
            }
        }
    }

    updatePreferencePropertyValue(key: string, value, parentMode: boolean = true, index: number = undefined, i18n = defaultI18n) {
        if(parentMode) {
            this.currentPreference.preferenceItemCodes[0][key] = value;
        } else {
            this.currentPreference.combinedPreferences[index].preferenceItemCodes[0][key] = value;
        }
        this.lastPreferenceUpdateTime = Date.now(); 
        if(this.preferenceId) {
            this.savePreference(i18n);
        }
        this.notifyPreferenceUpdateObservers();
    }

    updateProductProperty(propertyId, fieldName: string, value, i18n = defaultI18n) {
        this.updatePreferencePropertyValue(fieldName, value, i18n);
    }

    updatePropertyValueField(propertyValue, i18n = defaultI18n) {
        try {
            if(!this.currentPreference.preferenceItemCodes[0].value) {
                this.currentPreference.preferenceItemCodes[0].value = propertyValue;
                this.updatePreferencePropertyValue('value', propertyValue, i18n);
            }
            this.notifyPreferenceUpdateObservers();
        } catch(err) {
            console.log(err);
        }
    }

    getProperty() {
        return this.currentPreference.preferenceItemCodes[0];
    }

    updateValueLocalization(locale: Locale, value: string, code: string, propertyId?: string) {
        try {
            let definitionPropertyId = propertyId;
            if (!definitionPropertyId) {
                const itemCode = this.getProperty()?.itemCode;
                definitionPropertyId = propertiesStorage.getItems(true).find(
                    (it) => it.propertyName === itemCode,
                )?.id;
            }
            if (!definitionPropertyId || !checkItemLocaleCode(code)) {
                return;
            }
            postFetchRequest(makeUrl([PROPERTIES_URL, definitionPropertyId, '/value/', code, '/name/']),
                {
                    localizedName: value,
                    locale: locale,
                },
                () => {
                    propertiesService.upsertValueNameInStorage(definitionPropertyId, locale, code, value);
                }, errorCallback, true);
        } catch(err) {
            console.log(err);
        }
    }
}

export const preferenceSaveService = new PreferenceSaveService();

export const initializePreferenceSaveService = (preferenceId: string) => {
    preferenceSaveService.cleanService();
    preferenceSaveService.preferenceId = preferenceId;
    preferenceSaveService.loadPreference();
};
